import React, { useState, useRef, useEffect } from 'react';
import { useForm } from 'react-final-form';
import { Button, Flex } from '@tpr/core';
import { FFInputText } from '../text/text';
import { postcodeValidator } from './services';
import styles from './addressLookup.module.scss';
export var PostcodeLookup = function (_a) {
    var loading = _a.loading, testId = _a.testId, postcode = _a.postcode, onPostcodeChanged = _a.onPostcodeChanged, invalidPostcodeMessage = _a.invalidPostcodeMessage, postcodeLookupLabel = _a.postcodeLookupLabel, postcodeLookupButton = _a.postcodeLookupButton, findAddressCancelledButton = _a.findAddressCancelledButton, onFindAddressCancelled = _a.onFindAddressCancelled;
    var form = useForm();
    var searchFieldRef = useRef(null);
    var _b = useState(false), postcodeValid = _b[0], setPostcodeValid = _b[1];
    var clickFindAddress = function () {
        postcodeValid &&
            onPostcodeChanged(form.getFieldState('postcodeLookup').value);
    };
    useEffect(function () {
        searchFieldRef.current.value = null;
        searchFieldRef.current.focus();
    }, []);
    var validatePostcode = function (value) {
        var result = postcodeValidator(value, invalidPostcodeMessage);
        typeof result === 'undefined'
            ? setPostcodeValid(true)
            : setPostcodeValid(false);
        return result;
    };
    var handleKeyPress = function (e) {
        if (e.key === 'Enter') {
            e.preventDefault();
            clickFindAddress();
        }
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(FFInputText, { ref: searchFieldRef, name: "postcodeLookup", autoComplete: "postal-code", value: postcode, label: postcodeLookupLabel, required: true, validate: function (value) { return searchFieldRef.current && validatePostcode(value); }, testId: (testId ? testId + '-' : '') + 'postcode-lookup-edit', inputClassName: styles.editPostcode, disabled: loading, onKeyPress: handleKeyPress }),
        React.createElement(Flex, { cfg: {
                flexDirection: 'row',
                mt: 2,
                alignItems: 'center',
            } },
            React.createElement(Button, { testId: (testId ? testId + '-' : '') + 'postcode-lookup-button', onClick: clickFindAddress, appearance: "secondary", "aria-disabled": !postcodeValid }, postcodeLookupButton),
            onFindAddressCancelled && (React.createElement(Button, { cfg: { ml: 3 }, onClick: onFindAddressCancelled, testId: (testId ? testId + '-' : '') + 'find-address-cancel-button', appearance: "secondary" }, findAddressCancelledButton)))));
};
//# sourceMappingURL=postcodeLookup.js.map